import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import ClientTip, {ClientTipDto} from './client-tip';
import { HttpClient, HttpParams } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClientTipService {
  private http = inject(HttpClient);

  getClientTips$(clientId: string, categorieId: string, taakId: string): Observable<Array<ClientTip>> {
    const params = new HttpParams()
      .set('clientId', clientId)
      .set('categorieId', categorieId)
      .set('taakId', taakId);
    return this.http.get<Array<ClientTipDto>>(`${environment.apiUrl}/clienttips`, {params})
      .pipe(map(dtos => dtos.map(dto => ClientTip.deserialize(dto))));
  }

  postClientTip$(clientId: string, dienstId: string, categorieId: string, taakId: string, content: string): Observable<ClientTip> {
    return this.http.post<ClientTipDto>(`${environment.apiUrl}/clienttips`, {clientId, dienstId, categorieId, taakId, content})
      .pipe(map(dto => ClientTip.deserialize(dto)));
  }

  putClientTip$(id: string, content: string): Observable<ClientTip> {
    return this.http.put<ClientTipDto>(`${environment.apiUrl}/clienttips/${id}`, {content})
      .pipe(map(dto => ClientTip.deserialize(dto)));
  }

  deleteClientTip$(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/clienttips/${id}`);
  }
}
